var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreateCollection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_708",
    "data-name": "Group 708",
    transform: "translate(-251 -797)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1037",
    "data-name": "Rectangle 1037",
    width: 51,
    height: 51,
    transform: "translate(251 797)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_collection_2355468",
    transform: "translate(257 803)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M17.637,2.5H4.443A1.943,1.943,0,0,0,2.5,4.443V17.678a1.943,1.943,0,0,0,1.943,1.943H17.678a1.943,1.943,0,0,0,1.943-1.943V4.443A2,2,0,0,0,17.637,2.5Z",
    transform: "translate(-2.5 -2.5)",
    fill: "none",
    stroke: "#366eef",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M70.437,2.5H57.243A1.943,1.943,0,0,0,55.3,4.443V17.678a1.943,1.943,0,0,0,1.943,1.943H70.478a1.943,1.943,0,0,0,1.943-1.943V4.443A1.978,1.978,0,0,0,70.437,2.5Z",
    transform: "translate(-33.93 -2.5)",
    fill: "none",
    stroke: "#366eef",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M17.637,55.3H4.443A1.943,1.943,0,0,0,2.5,57.243V70.478a1.943,1.943,0,0,0,1.943,1.943H17.678a1.943,1.943,0,0,0,1.943-1.943V57.243A2.034,2.034,0,0,0,17.637,55.3Z",
    transform: "translate(-2.5 -33.93)",
    fill: "none",
    stroke: "#366eef",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M70.437,55.3H57.243A1.943,1.943,0,0,0,55.3,57.243V70.478a1.943,1.943,0,0,0,1.943,1.943H70.478a1.943,1.943,0,0,0,1.943-1.943V57.243A2.005,2.005,0,0,0,70.437,55.3Z",
    transform: "translate(-33.93 -33.93)",
    fill: "none",
    stroke: "#366eef",
    strokeWidth: 2
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateCollection);
export default __webpack_public_path__ + "static/media/createCollection.1cb1aae3345de0b708a35b36d2740c6b.svg";
export { ForwardRef as ReactComponent };